import { Typography } from '../../../summary/components/Typography.js';
import { PNG_HEIGHT, PNG_WIDTH } from '../../summaryV2/utils/constants.js';
import { MarketTrendsSummaryChart } from './MarketTrendsSummaryChart.js';
import { MarketTrendsSummaryTable } from './MarketTrendsSummaryTable.js';
import { MarketTrendsExportDeps, MarketTrendsHelpers } from './types.js';

type Props = {
  exportDeps?: MarketTrendsExportDeps;
  marketTrendsHelpers: MarketTrendsHelpers;
};

export function MarketTrendsSummary(props: Props) {
  const { exportDeps, marketTrendsHelpers } = props;
  const { attribution } = marketTrendsHelpers;

  return (
    <>
      <MarketTrendsSummaryTable marketTrendsHelpers={marketTrendsHelpers} />
      <MarketTrendsSummaryChart
        width={exportDeps === undefined ? undefined : PNG_WIDTH}
        height={exportDeps === undefined ? 250 : PNG_HEIGHT}
        exportDeps={exportDeps}
        marketTrendsHelpers={marketTrendsHelpers}
      />
      {attribution && <Typography variant="body2">{attribution}</Typography>}
    </>
  );
}
